<div
  id="badge_{{ badgeData?.key }}"
  class="inline-block py-0.5 px-2 text-xs rounded-full font-medium whitespace-nowrap {{ badgeData?.type }}"
  [style]="badgeData?.badgeStyle">
  <ng-content></ng-content>
  {{ badgeData?.value }}
</div>
